const postSites = {
  toastr: 'Site adicionado',
  toastr1: ' foi adicionado com sucesso',
  toastrError: 'Site já cadastrado',
  toastrError1: 'Insira outro nome'
};

export default postSites;
